import {useMutation, useQueryClient} from '@tanstack/react-query';
import {ConversationMessage} from '@/types/conversationMessage';
import conversationMessagesUpdaters from '@/api/updaters/conversationMessages';
import {CONVERSATION_MESSAGES_QUERY_KEY} from '@/hooks/queries/use-conversation-messages-query';

function useSendMessage() {
  const queryClient = useQueryClient();

  return useMutation<
    ConversationMessage,
    Error,
    {conversationId: string; body: string; sentFromBrandId: string}
  >({
    mutationKey: ['conversations', 'sendMessage'],
    mutationFn: conversationMessagesUpdaters.sendMessage,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [CONVERSATION_MESSAGES_QUERY_KEY, variables.conversationId],
      });
    },
  });
}

export default useSendMessage;
